module.exports = __webpack_public_path__ + "assets/img/36_1443.0ddb0d46.jpg";